<div class="spinner-bg" *ngIf="loader">
    <ul class="spinner white-bg">
        <li class="bounce1"></li>
        <li class="bounce2"></li>
        <li class="bounce3"></li>
    </ul>
</div>
<div id="wifi-connecting-wait" class="wifi-connecting-wait auto-height text-white wifi-text-spinner" *ngIf="loaderwithtext">
    <div class="wrapper">
        <div class="row-wrapper">
            <header class="mrgn-b-40">
                <div class="spinner-bg">
                    <ul class="spinner white-bg">
                        <li class="bounce1"></li>
                        <li class="bounce2"></li>
                        <li class="bounce3"></li>
                    </ul>
                </div>
                <h2>{{loaderwithtext?.loaderSubHeaderText | translate}}</h2>
                <div class="loader-subtext" *ngIf="loaderwithtext.loaderSubHeaderText">
                    <p [innerHtml]="loaderwithtext.loaderSubHeaderText | translate"></p>
                </div>
            </header>
        </div>
    </div>
</div>